interface SpinnerProps {
  size?: 'sm' | 'md'
}

export function Spinner({ size = 'md' }: SpinnerProps) {
  const s = size === 'sm' ? 'h-4 w-4' : 'h-6 w-6'
  return (
    <div
      className={`${s} animate-spin rounded-full border-2 border-(--color-border) border-t-(--color-primary)`}
    />
  )
}
